export default __webpack_public_path__ + "static/media/astrox_3dg.f430e3e9.webp";